<template>
	<div class="content">
		<div class="content_head">
			<p><input type="text" @keypress="pageIndex=1;getData()" placeholder="会员手机号|会员姓名" class="search"
					v-model="searchText" />
				<button type="button" class="button" @click="getData()">查询</button>
			</p>
		</div>
		<div class="content_body">
			<table>
				<thead>
					<tr>
						<th>序号</th>
						<th>订单信息</th>
						<th>借书详情</th>
						<th>运费</th>
						<th>收货地址</th>
						<th>处理店铺</th>
						<th>订单状态</th>
						<th>配书</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(i,index) in orders">
						<td>
							{{index+1}}
						</td>
						<td style="text-align: left;">
							订单时间:<span class="red"> {{i.OrderDate}}</span><br />
							客户编号:<span class="red"> {{i.OrderCode}}</span><br />
							客户姓名:<span class="red">{{i.CustomerName}}</span><br />
							联系方式:<span class="red">{{i.CustomerPhone}}</span><br />
							客户归属:<span class="red">{{i.shopName}}</span><br />
							书籍数量:<span class="red">{{i.BookNums+'本'}}</span>
						</td>

						<td style="text-align: right;">
							<p v-for='j in i.books'>
								<span class="red"> {{j.BooksName + "-"+ j.BooksCount+"本"}}</span>
							</p>
						</td>

						<td>
							应付:<input type="text" v-model="i.FreightMoney"
								style="width:2rem;text-align: right;padding: .3rem .5rem;" />¥
							<br />
							实付:<input type="text" v-model="i.ActualPayment"
								style="width:2rem;text-align: right;padding: .3rem .5rem;" />
							¥
						</td>
						<td>

							<p v-for="j in shop">
								<button type="button" class="button" @click="i.Destination=j.ShopName"
									:class="{'disabled':j.ShopName!=i.Destination}">{{j.ShopName}}</button>
							</p>
						</td>
						<td class="left">
							{{i.shopName}}
						 <br />
							<select v-model="i.TransporterID" style="line-height: 1.5rem;width: 6rem;">
								<option v-for="(j,index) in Transporter" :value="j.UserID">{{j.UserName}}</option>
							</select>
						</td>
						<td>
							<span class="red">{{i.OrderState==0?"付款":"待处理"}}</span>
						</td>
						<td>

							<button type="button" class="button" @click="updateOrder(i)"> 更新订单 </button>
							<br />
							<button type="button" class="button" :class="{'disabled':i.TransporterID==0}"
								:disabled="i.TransporterID==0" @click="customerOrderSend(i)"> 取回书籍 </button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="foot_pages">
			<button class="button" :class="{'disabled':up}" :disabled="up" @click="changePages('up')">上一页</button>
			<span>{{page}}</span>

			<select v-model="pageRows" @change="changePageRows">
				<option value="10">10/页</option>
				<option value="20">20/页</option>
				<option value="30">30/页</option>

			</select>
			<button class="button" :class="{'disabled':down}" :disabled="down" @click="changePages('down')">下一页</button>
		</div>
	</div>


</template>

<script>
	import j from './index.js'
	export default j
</script>

<style>
</style>
